module.exports = __webpack_public_path__ + "img/tutorial_img_2_1.3594ea86.png";